import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { caseQuickUpdate } from '../../../../../lib/fetchApi'
import { notificationActions } from '../../../../../store/notifications'
import { caseActions } from '../../../../../store/case'

import classes from '../../GroupNew/GroupItemSearch.module.css'

export default function NegotiationEntirySearchAndSetItem ({item, data, fieldsData, action, folder, entityType}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [loading, setLoading] = useState(false)

    const selectOptionHandler = async () => {
        setLoading(true)
        try {
            // let reqBody = {
            //     type: `case_negotiation`,
            //     fields: {
            //         entity_type: entityType,
            //         entity_type_id: item.id
            //     }
            // }   
            
            let reqBody = {
                type: `case_attorney`,
                type_id: data.id,
                fields: {
                    negotiator_id: item.id,
                    negotiator_type: entityType,
                }
            }   

            const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)

            if (update && update.errorMessage) {            
                dispatch(notificationActions.setError(update))
            } else {            
                const entity = update?.data ?? update
                if (entity && !update?.staleResponse && !update?.aborted) {
                    
                    let dispatchBody = {
                        folder: folder,
                        item: {
                            itemId: data.id,
                            fields: [
                                {
                                    field: 'negotiator_id',
                                    value: entity?.id
                                },
                                {
                                    field: 'negotiator_type',
                                    value: entityType
                                },
                                {
                                    field: 'negotiator',
                                    value: entity
                                }
                            ]              
                        },
                    }    
                    
                    dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
                }

                action()
            } 
        } finally {
            setLoading(false)
        }
    }

    return <div className={classes.searched_option}>
        <button onClick={selectOptionHandler}>
            {item.name}
            {loading && <span className="loader dark"></span>}
        </button>
    </div>
}